import { useMemo } from 'react';
import capitalize from 'lodash/capitalize';

import { SortingListItem } from '../types';
import { useOpenSearchContext } from './useOpenSearchContext';
import { useUpdateSearchParams } from './useUpdateSearchParams';
import { getFieldAndOrderFromSortFilter } from '../utils';

const useSortingMenu = ({ items, attributeMapping }: Args) => {
  const { updateSearchParams } = useUpdateSearchParams();

  const { sortFilter, updateSortFilter, updateFrom } = useOpenSearchContext();
  const { field, order } = getFieldAndOrderFromSortFilter(
    sortFilter,
    attributeMapping,
  );

  const activeSort = useMemo(
    () =>
      items.find(({ value }) => value.field === field && value.order === order),
    [items, field, order],
  );

  const applySort = ({ value: { field, order } }: SortingListItem) => {
    const sortQueryParam = `${field}${capitalize(order)}`;

    updateSearchParams({ sort: [sortQueryParam], page: '1' });
    updateFrom(0);
    updateSortFilter([{ [field]: { order, missing: '_last' } }]);
  };

  return { activeSort, items, applySort };
};

type Args = {
  items: SortingListItem[];
  attributeMapping?: Record<string, string>;
};

export { useSortingMenu };
